import { render, staticRenderFns } from "./RecyclableBoxUpdate.vue?vue&type=template&id=c0c86160&scoped=true&"
import script from "./RecyclableBoxUpdate.vue?vue&type=script&lang=js&"
export * from "./RecyclableBoxUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RecyclableBoxUpdate.vue?vue&type=style&index=0&id=c0c86160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c86160",
  null
  
)

export default component.exports